import styled from "styled-components";

import {
  H2,
  Color,
  Font,
  FontSize,
  LineHeight,
  Margin,
} from '../../../styles'

export const ProdTitle = styled(H2)`
  font-family: ${Font.primary};
  font-size: ${FontSize.productTitle};
  font-weight: 800;
  line-height: ${LineHeight.productSpecs};
  text-transform: uppercase;
  color: ${Color.black};
  margin-bottom: ${Margin.subheadCopyMargin};

  @media (min-width: 1281px) {
    font-size: ${FontSize.productTitle};
    line-height: ${LineHeight.productSpecs};
  }
`;